module.exports = "<div *ngIf=\"show\" class=\"environment-banner\" tooltip=\"{{buildNumber}}\" [tooltipDisabled]=\"!buildNumber\">\r\n    {{environment}}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./~/@nordpoolgroup/nps-angular-2-common/src/Environment/EnvironmentComponent.html
// module id = 682
// module chunks = 0